import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AlertBanner = ({ alerts }) => {
  const highPriorityAlert = alerts.find(a => a.severity === 'High');

  if (!highPriorityAlert) return null;

  return (
    <div className="bg-alert text-white py-3 px-4 relative overflow-hidden">
      <div className="container-custom flex items-center gap-3">
        <span className="bg-white text-alert text-xs font-bold px-2 py-0.5 rounded uppercase animate-pulse shrink-0">
          Breaking Alert
        </span>
        <div className="flex-1 overflow-hidden">
          <a 
            href={highPriorityAlert.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="block"
          >
            <motion.div 
              initial={{ x: "100%" }}
              animate={{ x: "-100%" }}
              transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
              className="whitespace-nowrap font-medium text-sm hover:underline"
            >
              {highPriorityAlert.title} — CLICK FOR FULL CDC/FDA DETAILS — {highPriorityAlert.summary}
            </motion.div>
          </a>
        </div>
        <button className="text-white hover:text-gray-200 shrink-0">
          <SafeIcon icon={FiIcons.FiX} />
        </button>
      </div>
    </div>
  );
};

export default AlertBanner;